import React from "react";

export default function Footer({ profile }) {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-[#1c1c1c] mt-10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="font-serif text-2xl tracking-tight text-[#FAFAFA]">
          Soham Sunthankar<span className="text-[#5a5a5a]">.</span>
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#6a6a6a]">
          © {year} — {profile?.location || "Pune, India"} — Words & Music
        </div>
      </div>
    </footer>
  );
}
